import { takeLatest, put } from 'redux-saga/effects';
import handleStatusCode from 'Store/Api/HandleStatusCode';
import { PostFile } from 'Store/Api/CallApi';
import { ADMIN_BULK_GROUP_ENTITY_PROJECT_UPLOAD } from 'Store/Api/ApiEndpoints';
import { REQUEST_BULK_GROUP_ENTITY_PROJECT_UPLOAD, bulkGroupEntityProjectUploadSuccess } from 'Store/Areas/BulkUpload/BulkGroupEntityProjectUploadActions';

/* Worker Sagas */

function* postSelectedFile(action) {
  const formData = new FormData();
  formData.append('file', action.file);

  const response = yield PostFile(ADMIN_BULK_GROUP_ENTITY_PROJECT_UPLOAD, formData);
  if (response.ok) {
    const data = yield response.json();
    yield put(bulkGroupEntityProjectUploadSuccess(data));
  } else {
    yield handleStatusCode(response.status);
  }
}

/* Watcher Sagas */
export function* bulkGroupEntityProjectUploadSagas() {
  yield takeLatest(REQUEST_BULK_GROUP_ENTITY_PROJECT_UPLOAD, postSelectedFile);
}
